module.exports = __webpack_public_path__ + "c02f5da6e82e1efe0b45841bfd49ce37.woff2";